export const playingBar = {
  'Now playing view': 'Now playing view',
  Lyrics: 'Lyrics',
  Queue: 'Queue',
  'Connect to a device': 'Connect to a device',
  Mute: 'Mute',
  Unmute: 'Unmute',
  'Full Screen': 'Full Screen',
  'Now playing': 'Now playing',
  Next: 'Next',
  Experience: 'Experience',
  Description: 'Description',
  Images: 'Images',
  'Current device': 'Current device',
  'Exit full screen': 'Salir de pantalla completa',
};
